<script>
  import Progressbar from "./progressbar.svelte";

  let el1;

  let total = 0;
  let completed = 0;
  let showProgressBar = false;

  const mountOpportunityTeams = async () => {
    const { default: OpportunityTeams } = await import(
      "App/OpportunityTeams"
    );

    if (el1) {
      el1.innerHTML = "";
      new OpportunityTeams({
        target: el1,
        props: {
          translation: {
            firstName: "First Name",
            lastName: "Last Name",
            email: "Email",
            phone: "Phone",
            title: "Title",
          },
          schema: {
            actions: {
              edit: { removable: true, "with-confirmation": true },
            },
            "field-properties": {
              "auto-generated-fields": [
                "id",
                "opportunityId",
                "firstName",
                "lastName",
                "email",
                "phone",
                "title",
              ],
              "field-order": ["firstName", "lastName", "email", "phone", "title"],
            },
            // "custom-bulk-actions": [
            //   {
            //     action: "Sync to AWS",
            //     bulkFn: async (ids) => {
            //       showProgressBar = true;
            //       total = ids.length;
            //       completed = 0;

            //       const results = [];
            //       for (const teamId of ids) {
            //         const oppRes = await fetch(
            //           `${process.env.SVELTE_APP_REMOTE_URL}/api/opportunities?filter={"where":{"opportunityTeams":{"id":${teamId}}}}`
            //         );
            //         const opportunities = await oppRes.json();

            //         if (!opportunities.length) {
            //           results.push({
            //             success: false,
            //             message: `No opportunity found for team member ${teamId}`,
            //           });
            //           completed++;
            //           continue;
            //         }

            //         for (const opp of opportunities) {
            //           const res = await fetch(
            //             `${process.env.SVELTE_APP_REMOTE_URL}/api/sync/opportunity/${opp.id}`,
            //             { method: "POST" }
            //           );
            //           results.push(await res.json());
            //         }

            //         completed++;
            //       }

            //       showProgressBar = false;
            //       return results;
            //     },
            //     singleFn: async (row) => {
            //       const oppRes = await fetch(
            //         `${process.env.SVELTE_APP_REMOTE_URL}/api/opportunities?filter={"where":{"opportunityTeams":{"id":${row.id}}}}`
            //       );
            //       const opportunities = await oppRes.json();

            //       if (!opportunities.length) {
            //         return { success: false, message: "No opportunity found for this team member" };
            //       }

            //       const results = [];
            //       for (const opp of opportunities) {
            //         const res = await fetch(
            //           `${process.env.SVELTE_APP_REMOTE_URL}/api/sync/opportunity/${opp.id}`,
            //           { method: "POST" }
            //         );
            //         results.push(await res.json());
            //       }

            //       return { success: true, synced: results };
            //     },
            //   },
            // ],
          },
        },
      });
    }
  };

  mountOpportunityTeams();
</script>

{#if showProgressBar}
  <Progressbar {completed} {total} />
{/if}

<div bind:this={el1} />
